import { Component, ViewChild } from '@angular/core';
import { NavController,  ViewController, Slides, ItemSliding, Item, AlertController, Searchbar,} from 'ionic-angular';

import { UserMyRadiant as User } from '../../../providers/';
import { Nav, NavParams, MenuController, Events, ModalController  } from 'ionic-angular';

import { RepositoryMyRadiant, HelperMyRadiant, OvertimeProvider, ApiMyRadiant} from '../../../providers/';
import { CalendarResult } from 'ion2-calendar';
import { cmpFilterKaryawan } from '../../../components/presensi';
import { AddOvertime } from '../add_overtime/page';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { File } from '@ionic-native/file';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import { Utility } from '../../../providers/resources/utility';
import { TabsPage } from '../../dashboard';
import { UserPresensi } from '../../../providers/presensi';

@Component({
  selector: 'presensi-overtime',
  templateUrl: 'page.html'
})
export class Overtime {
  berita:any = '';
  loading : any;
  isLogin : any = 0;
  data = {
    overtime:[],
    overtimeBawahan:[],
    verification:'',
    dateMulai:"",
    dateAkhir:"",
    dateJarak:"",
  };
  fitur = this.userPresensi.akses;
  state = {
    showList : 'me',
    addOvertime : true,
    searching : false,
  };
  startDate:any = new Date;
  valDateJarak:any;
  today = this.helper.getToday();
  parameter : any = {
    id  : this.userApi.data.Employee_ID,
    nik : this.userApi.data.NIK,
    date_start : this.today.awalYmd,
    date_end : this.today.akhirYmd,
    search : '',
    filter_data_overtime:'',
    verification : {
      id : null,
      action : null,
      id_karyawan :this.userApi.data.Employee_ID,
      nama_karyawan : this.userApi.data.Nama_Karyawan,
    }
  }
  fileTransfer: FileTransferObject = this.transfer.create();
  @ViewChild('slidingItem') private itemSliding: ItemSliding;
  @ViewChild('contentSlide') private contentSliding: Item;
  @ViewChild('widgetSearch') private searchBar: Searchbar;

  constructor(
    private api           : ApiMyRadiant,
    public userApi        : User,
    public alertCtrl      : AlertController,
    public nav            : Nav,
    public utility        : Utility,
    public repositoryProvider : RepositoryMyRadiant,
    public helper         : HelperMyRadiant,
    public viewCtrl       : ViewController,
    private overtimeProvider: OvertimeProvider, 
    private photoViewer   : PhotoViewer,
    private file          : File,
    private transfer      : FileTransfer,
    private events        : Events,
    private userPresensi  : UserPresensi,
    private navParams     : NavParams,
  ) {
    this.valDateJarak = {
  		from:this.today.obj.awal,
  		to:this.today.obj.akhir
    };
    this.parameter.filter_data_overtime = this.fitur.lihat_data_bawahan_overtime_group_data;
    this.parameter.verification.verificator = this.fitur.lihat_data_bawahan_overtime_group_data;
    // console.log("user presensi => ",this.userPresensi);
  }

  ionViewWillEnter() {
    let isNotification = this.navParams.get('isNotification');
    if (isNotification) {
      this.showKaryawan();
    }else{
      this.getOvertime();
    }
  }
  ionViewDidEnter(){
    // this.getOvertime();
  }

  getOvertime(){
    this.loading = this.helper.showLoading('Loading Data..');
    let me = this;
    this.repositoryProvider.getListOvertime(this.parameter).subscribe((resp:any) => {
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
      if(resp.success){
        me.data.overtime = resp.data;
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  getListOvertimeBawahan(){
    this.loading = this.helper.showLoading('Loading Data..');
    let me = this;
    this.repositoryProvider.getListOvertimeBawahan(this.parameter).subscribe((resp:any) => {
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
      if(resp.success){
        me.data.overtimeBawahan = resp.data;
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }
 
  showKaryawan(){
    let me = this;
    // this.loading = this.helper.showLoading('Loading Data..');
    if(me.state.showList == 'me'){
      me.state.showList = 'bawahan';
      me.state.searching = true;
      me.data.verification = '(Verification)';
      me.getListOvertimeBawahan();
      me.state.addOvertime = false;
    }else{
      me.state.showList = 'me';
      me.data.verification = '';
      me.state.addOvertime = true;
      me.state.searching = false;
      me.getOvertime();
    }
    
  }

  openCalendar() {
    let me = this;
    this.helper.valDateJarak = this.valDateJarak;
    this.helper.openCalendar((data,role) => {

      if (role=="done") {
        let date = data;
        let from: CalendarResult = date.from;
        let to: CalendarResult = date.to;	
          this.startDate = from.dateObj;
          this.parameter.date_start = from.string;
          this.parameter.date_end = to.string;
          this.data.dateJarak = this.helper.dateToString(from.dateObj) + ' s/d ' + this.helper.dateToString(to.dateObj);
          me.valDateJarak = {
            from : from.dateObj,
            to:to.dateObj
          }
          this.valDateJarak = {
            from : from.dateObj,
            to:to.dateObj
          };
          (me.state.showList) == 'me' ? me.getOvertime() : me.getListOvertimeBawahan();
          
      }
    })  
  }

  addOvertimeForm(){
    let page = this.nav.push(AddOvertime,{
      with_employee:false,
    });
    console.log("add my");
  }

  confirmVerification(state,overtime) {
    let me = this;
    let msg = 'Are you sure?';
    if(overtime.jam_lembur > overtime.plan_hours && state == 'menyetujui'){
      msg = 'Total hours exceed the overtime plan, are you sure?';
    }
    let generated_class_btn = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    let generated_class_label = Math.random().toString(36).substring(1, 15) + Math.random().toString(36).substring(1, 15);
    let akses = this.userPresensi.akses;
    if (akses['approve_overtime_request_hrd'] && state == 'menolak') {
      let element_content = `
        <div class="" style="width:100%;padding: 1px 10px;" >
          <textarea class="swal-content__textarea" rows="7" id="notes-overtime" placeholder="Enter Notes Here.."></textarea>  
        </div> 
        <div style="display:inline-grid;grid-template-columns: calc(100% - 50px) 50px;width:100%;padding: 0px 40px;text-align: left;padding-top: 10px;">
          <div>
              <span style="font-size: 13px;"> Attachment </span>
              <p class="text-biru `+generated_class_label+`" style="margin: 0px;font-size: 12px;"> `+this.helper.ifvalnull(overtime.file_name,'')+`</p>
          </div>
          <div style="text-align: right;">
              <button class="btn-camera item-button button button-ios button-default button-default-ios" style="background: #b5b9bc !important;font-size: 20px !important;padding: 0px !important;height: 30px !important;width: 40px;"><span
                      class="button-inner">
                      <ion-icon name="custom-camera" role="img" class="`+generated_class_btn+` btn-capture-img icon icon-ios ion-ios-custom-camera"
                          aria-label="custom camera" ng-reflect-name="custom-camera"></ion-icon>
                  </span>
                  <div class="button-effect"></div>
              </button> 
          </div>
        </div>
      `;
      let options = {
        buttonConfirm : "Yes",
        title         : msg,
        content       : element_content,
        dangerMode : true,
        eventListenerContent : true,
        cmpListeners : "approve-overtime",
        generated_class_btn : generated_class_btn,
        generated_class_label : generated_class_label
      };
      console.log(options,'parameters');
      this.helper.imageUrlSelected = this.helper.ifvalnull(this.api.url + overtime.src,this.api.url + '/uploads/no_img.jpg');

      this.helper.presentSwalCustomContent(options,(value) => {
        me.parameter.verification.id = overtime.id;
        me.parameter.verification.action = state;
        me.parameter.verification.filter_data = overtime.filter_data;
        me.parameter.verification.employee_name = overtime.name;
        me.parameter.verification.employee_user_id = overtime.user_id;
        me.parameter.verification.hrm_employee_id = overtime.hrm_employee_id;
        me.parameter.verification.filter_data = overtime.filter_data;
        me.parameter.verification.file_name    = this.helper.imageNameSelected;
        me.parameter.verification.binary_image = this.helper.imageSelected;
        me.parameter.verification.notes        = document.getElementById('notes-overtime')['value'];
        me.verificationAction();
      }); 
    }else{
      let options = {
        buttonConfirm : "Yes",
        title         : msg,
        content       : '',
        dangerMode    : false,
        eventListenerContent : true,
        cmpListeners : "approve-overtime",
        generated_class_btn : generated_class_btn,
        generated_class_label : generated_class_label
      };
      this.helper.presentSwalCustomContent(options,(value) => {
        me.parameter.verification.id = overtime.id;
        me.parameter.verification.action = state;
        me.parameter.verification.filter_data = overtime.filter_data;
        me.parameter.verification.employee_name = overtime.name;
        me.parameter.verification.employee_user_id = overtime.user_id;
        me.parameter.verification.hrm_employee_id = overtime.hrm_employee_id;
        me.parameter.verification.filter_data = overtime.filter_data;
        // me.parameter.verification.file_name    = this.helper.imageNameSelected;
        // me.parameter.verification.binary_image = this.helper.imageSelected;
        // me.parameter.verification.notes        = document.getElementById('notes-overtime')['value'];
        me.verificationAction();
      });
    }
    // const confirm = this.alertCtrl.create({
    //   title: 'Confirm Verification',
    //   message: msg,
    //   buttons: [
    //     {
    //       text: 'No',
    //       handler: () => {

    //       }
    //     },
    //     {
    //       text: 'Yes',
    //       handler: () => {
    //         me.parameter.verification.id = overtime.id;
    //         me.parameter.verification.action = state;
    //         me.parameter.verification.filter_data = overtime.filter_data;
    //         me.parameter.verification.employee_name = overtime.name;
    //         me.parameter.verification.employee_user_id = overtime.user_id;
    //         me.parameter.verification.hrm_employee_id = overtime.hrm_employee_id;
    //         me.parameter.verification.filter_data = overtime.filter_data;
    //         this.verificationAction();
    //       }
    //     }
    //   ]
    // });
    // confirm.present();

  }

  addOvertimeBawahan(){
    let me = this;
    me.nav.push(AddOvertime,{
      with_employee : true,
    });
  }

  verificationAction(){
    this.loading = this.helper.showLoading('Loading Data..');
    let me = this;
    this.overtimeProvider.verficationAction(this.parameter.verification).subscribe((resp:any) => {
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
      if(resp.success){
       me.getListOvertimeBawahan();
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
    
  } 

  showSearch(){
    this.state.searching = false; 
    this.searchBar._fireFocus();
    
    setTimeout(() => {
      this.searchBar.setFocus();
      this.searchBar._animated;
      console.log(this.state.searching);
    }, 500);
  }
  cancelSearch(){
    this.state.searching = true; 
    this.searchBar._fireBlur();
    setTimeout(() => {
      this.searchBar.inputBlurred();
    }, 500);
  }

  backMyRadiant(evt){
    this.nav.setRoot(TabsPage,{tabIndex:1});
    this.events.publish('modul:myradiant');
  }
}



// WEBPACK FOOTER //
// ./src/pages/presensi/overtime/page.ts